module.exports = __webpack_public_path__ + "img/OurServiceDigital_pic2.8b3a8d73.png";